.root {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  min-height: 60vh;
  padding: 32px;
  text-align: center;
}

.code {
  color: var(--color-foreground);
  font-size: 48px;
  font-weight: 700;
}

.message {
  color: var(--color-muted-foreground);
  font-size: 16px;
}

.button {
  background: var(--color-primary);
  border: none;
  border-radius: 8px;
  color: var(--color-primary-foreground);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  margin-top: 8px;
  padding: 10px 20px;
}
